import { createSharedState } from '@play-co/replicant';
import { teamCompetitionMessages } from './teamCompetition.messages';
import { teamCompetitionComputedProperties } from './teamCompetition.properties';
import { teamCompetitionSharedStateSchema } from './teamCompetition.schema';

export const teamCompetitionSharedState = createSharedState(
  teamCompetitionSharedStateSchema,
  teamCompetitionMessages,
  teamCompetitionComputedProperties,
);
